export default "__VITE_ASSET__CtDJA04a__"